export default {
  anyMistakes:
    'Hvis du mener at noe av informasjonen på denne siden ikke er korrekt, ber vi deg om å ',
  contactUs: 'kontakt oss',
  social: 'Vi er sosiale | Følg oss',
}
